import React, { useState, useEffect } from 'react';
import { Card, CardContent, Typography, Avatar, Box } from '@mui/material';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
export const TestimonialCarousel = ({ testimonials }) => {
  const [currentTestimonial, setCurrentTestimonial] = useState(0);
  const [expanded, setExpanded] = useState(false);

  const toggleExpand = () => {
    setExpanded(!expanded);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTestimonial(prev => (prev + 1) % testimonials.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [testimonials.length]);

  const handleDotClick = index => {
    setCurrentTestimonial(index);
  };

  const testimonial = testimonials[currentTestimonial];

  return (
    <Card style={{ boxShadow: 'none', borderRadius: '12px', backgroundColor: 'transparent', height: '100%' }}>
      <CardContent style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
        <div
          variant="body1"
          style={{
            fontSize: '16px',
            fontWeight: '500',
            color: '#131F32',
            cursor: 'pointer',
            maxHeight: expanded ? 'none' : '80%',
            overflow: 'hidden',
            display: '-webkit-box',
            WebkitBoxOrient: 'vertical',
            WebkitLineClamp: 4,
            lineClamp: 4,
            wordWrap: 'break-word' // Add word-wrap to handle long words
          }}
          onClick={toggleExpand}
        >
          {testimonial.text}
          {/* {!expanded && <span style={{ color: 'blue' }}> ... Read more</span>} */}
        </div>

        <Box display="flex" alignItems="center" marginTop="10px">
          <Avatar
            sx={{ width: 36, height: 36 }}
            alt="Author Icon"
          >
            {/* <img
              src={testimonial.icon}
              alt="Author Icon"
              style={{ width: '34px', height: '34px', objectFit: 'cover', borderRadius: '50%' }}
            /> */}
<AccountCircleIcon/>
          </Avatar>
          <div style={{ marginLeft: '20px', flex: 1 }}>
            <Typography variant="body2" style={{ fontSize: '14px', fontWeight: '650', color: '#131F32' }}>
              {testimonial.author}
            </Typography>
            <Typography variant="caption" style={{ fontSize: '12px', fontWeight: '500', color: '#9397A0' }}>
              {testimonial.position}
            </Typography>
          </div>
        </Box>
      </CardContent>
      <Box
        display="flex"
        justifyContent="center"
        position="relative"
        bottom="10px"
        marginTop="10px"
        marginBottom="10px"
        overflow='auto'
      >
        {testimonials.map((_, index) => (
          <Box
            key={index}
            component="span"
            onClick={() => handleDotClick(index)}
            sx={{
              width: '10px',
              height: '10px',
              borderRadius: '50%',
              backgroundColor: index === currentTestimonial ? '#FFD600' : '#ccc',
              mx: '5px',
              cursor: 'pointer',
            }}
          />
        ))}
      </Box>
    </Card>
  );
};

export default TestimonialCarousel;
